import { render, staticRenderFns } from "./FactorCalendarMonth.vue?vue&type=template&id=b4bd153e&scoped=true"
import script from "./FactorCalendarMonth.vue?vue&type=script&lang=ts"
export * from "./FactorCalendarMonth.vue?vue&type=script&lang=ts"
import style0 from "./FactorCalendarMonth.vue?vue&type=style&index=0&id=b4bd153e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bd153e",
  null
  
)

export default component.exports